import { render, staticRenderFns } from "./EduriWidget.vue?vue&type=template&id=61f206c8&"
import script from "./EduriWidget.vue?vue&type=script&lang=js&"
export * from "./EduriWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports